import { Alert, Snackbar } from '@mui/material';
import ReactDOM from 'react-dom/client';
import React from 'react';

const showSnackbar = ({ errors, type }) => {
  const snackbarContainer = document.createElement('div');
  document.body.appendChild(snackbarContainer);

  const root = ReactDOM.createRoot(snackbarContainer);

  const handleClose = () => {
    root.unmount();
    document.body.removeChild(snackbarContainer);
  };

  let finalMessage = 'You do not have permission to perform this action';

  if (Array.isArray(errors) && errors.length > 1) {
    finalMessage = (
      <ul>
        {errors.map(msg => {
          if (msg?.message) {
            return <li key={msg?.message}>{msg?.message}</li>;
          }

          return <li key={msg}>{msg}</li>;
        })}
      </ul>
    );
  } else if (Array.isArray(errors) && errors.length === 1) {
    if (errors[0]?.message) {
      finalMessage = errors[0].message;
    }

    if (typeof errors[0] === 'string') {
      // eslint-disable-next-line prefer-destructuring
      finalMessage = errors[0];
    }
  } else if (errors?.message) {
    finalMessage = errors.message;
  } else if (errors) {
    finalMessage = errors;
  }

  root.render(
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open
      autoHideDuration={3000}
      onClose={handleClose}>
      <Alert severity={type || 'success'} variant="filled">
        {finalMessage}
      </Alert>
    </Snackbar>,
  );
};

export default showSnackbar;
